import React, { useEffect, useState } from 'react';
import { Paper, Box,  Grid2, Container, CircularProgress} from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import ConversacionPorLinea from '../components/Charts/ConversationBusiness';
import UltimasConversaciones from '../components/Charts/LastConversations';
import FlujosTerminados from '../components/Charts/FlowFinished';
import ConversacionesPorDia from '../components/Charts/ConversationTimeLine';
import { fetchConversationChartsFromAPI } from '../Redux/ConversationDucks';

const getUserBusinessLineIds = () => {
    const cookies = document.cookie.split('; ');
    const perfilCookie = cookies.find(c => c.startsWith('perfil='));
    const perfil = perfilCookie ? decodeURIComponent(perfilCookie.split('=')[1]) : '';
    if (perfil === 'Super-Admin') return null;
    const blCookie = cookies.find(c => c.startsWith('businessLineIds='));
    if (!blCookie) return [];
    return blCookie.split('=')[1].split(',').map(Number).filter(Boolean);
};

const DashboardMessagingPage = () => {
    const dispatch = useDispatch();
    const allFlowList = useSelector(store => store.flow.flowMenu) || [];
    const userBLIds = getUserBusinessLineIds();
    const flowList = userBLIds === null
        ? allFlowList
        : allFlowList.filter(flow => userBLIds.includes(flow.businessLineId));
    const conversationCharts = useSelector(store => store.conversation.conversationCharts);
    const [loading, setLoading] = useState(false);

    const [chartData, setChartData] = useState({});

    const fetchData = () => {
        setLoading(true)
        dispatch(fetchConversationChartsFromAPI())
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (conversationCharts.lastConversations)
            setLoading(false)
        setChartData(conversationCharts);
    }, [conversationCharts]);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            {loading ? (
                <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress />
                    <div>Loading...</div>
                </Box>
            ) : (
                <Grid2 container spacing={3}>
                    {/* Fila superior */}
                    <Grid2 size={4}>
                        <UltimasConversaciones ConversationData={chartData.lastConversations ?? []} />
                    </Grid2>
                    <Grid2 size={4}>
                        <ConversacionPorLinea ConversationData={chartData.conversationsByLine ?? []} />
                    </Grid2>
                    <Grid2 size={4}>
                        <FlujosTerminados ConversationData={chartData.finishedFlows ?? []} />
                    </Grid2>

                    {/* Gráfico principal */}
                    <Grid2 size={12}>
                        <ConversacionesPorDia ConversationData={chartData.conversationsByDay ?? []} />
                    </Grid2>

                    {/* Cards de flowList */}
                    {flowList.map((flow, index) => (
                        <Grid2 key={index} size={4}>
                            <Paper elevation={3} sx={{ padding: 2 }}>
                                <Box display="flex" justifyContent="center">
                                    <a href={`/messaging/flow/${flow.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                        {flow.name}
                                    </a>
                                </Box>
                            </Paper>
                        </Grid2>
                    ))}

                </Grid2>
            )}
        </Container>
    );
}



export default DashboardMessagingPage;